<template>
    <el-form label-position="top" :rules="rules" ref="ruleFormRef" :model="values" @submit.prevent>
        <div class="row">
            <el-form-item label="Şərt" prop="descr" label-position="top">
                <el-input v-model="values.descr"></el-input>
            </el-form-item>
        </div>

        <div class="row dialog-btn">
            <div>
                <soft-button @click="SubmitForm()" color="success">
                    {{ !this.editing ? 'Daxil et' : 'Qəbul et' }}</soft-button>
                &nbsp;&nbsp;&nbsp;
                <soft-button @click="this.$emit('close-dialog')" color="secondary">Imtina</soft-button>
            </div>
        </div>
    </el-form>
</template>
<script>
import SoftButton from "@/components/SoftButton.vue"; 

export default {
    components: {
        SoftButton
    },
    props: {
        editing: Boolean,
        object: Object
    },
    data() {
        return {
            values: {},
            rules: {
                descr: [{ required: true, message: 'Mütləq sahə', trigger: 'change' }],
            }
        }
    },
    methods: {
        SubmitForm() {
            this.$refs.ruleFormRef.validate(valid => {
                if (valid) { 
                    //None
                }
            })
        }
    },
    mounted() {
        if (this.editing) {
            this.values = { ...this.object }
        }
    },
}
</script>